import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100%",
  },
  paper: {
    background: theme.hv.palette.base.base2,
    maxHeight: "100% !important",
  },
  fullscreenCarousel: {},
  closeButton: {
    zIndex: 1,
    "& path": {
      fill: `${theme.hv.palette.atmosphere.atmo4}!important`,
    },
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "transparent",
      "& path": {
        fill: `${theme.hv.palette.atmosphere.atmo1}!important`,
      },
    },
  },
}));

export default styles;
